module.exports = "<ing-data-grid2\r\n  [dataLst]=\"dataLst\"\r\n  [fields]=\"fields\"\r\n  [newItemText]=\"newItemText\"\r\n  [rowsOnPage]=\"rowsOnPage\"\r\n  [sortBy]=\"sortBy\"\r\n  [sortOrder]=\"sortOrder\"\r\n  [renderBtnNuevo]=\"renderBtnNuevo\"\r\n  [grid-buttons]=\"gridButtons\"\r\n  (edit)=\"onEdit($event)\"\r\n  (create)=\"onCreate($event)\"\r\n  (delete)=\"onDelete($event)\"\r\n  (grid-click)=\"onGridClick($event)\"\r\n></ing-data-grid2>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/data-list/data-list/data-list.component.html
// module id = 1301
// module chunks = 4